import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import CtaStyle2 from '../Cta/CtaStyle2';
import AboutStyle6 from '../About/AboutStyle6';
import CardStyle3 from '../Card/CardStyle3';
import { pageTitle } from '../../helpers/PageTitle';

export default function CustomQuotationsPage() {
  pageTitle('Custom Quotations - Soketry Solutions');

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Tailored Quotations for Every Need"
        subTitle="Custom Quotations"
        shape="shape_3"
      />
      <Spacing lg="75" md="60" />
      <div className="cs_service_info">
        <div className="container">
          <div className="row align-items-center cs_gap_y_40">
            <div className="col-lg-6">
              <div
                className="cs_service_info_thumb cs_bg_filed"
                style={{
                  backgroundImage: 'url("/images/custom-quotations/custom-quotations-1.jpg")',
                }}
              />
            </div>
            <div className="col-lg-6">
              <div className="row cs_gap_y_40">
                <div className="col-sm-6">
                  <CardStyle3
                    number="01"
                    title="Residential Energy Solutions"
                    subTitle="Get customized quotes for solar installations, energy efficiency upgrades, and more tailored specifically to your home and energy needs."
                  />
                </div>
                <div className="col-sm-6">
                  <CardStyle3
                    number="02"
                    title="Commercial Energy Assessments"
                    subTitle="Detailed quotations for commercial properties, focusing on cost-effective solutions to reduce energy expenses and improve sustainability."
                  />
                </div>
                <div className="col-sm-6">
                  <CardStyle3
                    number="03"
                    title="Industrial Energy Management"
                    subTitle="We provide bespoke quotations for large-scale industrial energy projects, including renewable energy integration and energy optimization strategies."
                  />
                </div>
                <div className="col-sm-6">
                  <CardStyle3
                    number="04"
                    title="Sustainable Development"
                    subTitle="Customized quotes for projects aimed at achieving sustainability goals, including green certifications and environmental impact assessments."
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Spacing lg="150" md="80" />
      <AboutStyle6
        thumbnailSrc="/images/custom-quotations/custom-quotations-2.jpg"
        title="Why Choose Our Custom Quotations?"
        subTitle="Our custom quotations are designed to provide you with the best solutions that match your specific needs and budget, ensuring maximum return on investment."
        featureList={[
          'Personalized Service',
          'Competitive Pricing',
          'Comprehensive Analysis',
          'Flexible Solutions',
        ]}
        btnText="Explore Our Projects"
        btnUrl="/portfolio"
      />
      <Spacing lg="150" md="80" />
      <CtaStyle2
        title="Ready to Explore Your Options?"
        btnText="Contact Us Today"
        btnUrl="/contact"
      />
      <Spacing lg="150" md="80" />
    </>
  );
}
